import { UseMutationOptions, UseMutationResult, useMutation } from "@tanstack/react-query";
import { IPatchActionParams, patchSectorWorkflowAction } from "../actions/sector-workflow.actions";

export interface IUsePatchMutationParams<TResponse, TBody> {
  mutationOptions?: UseMutationOptions<TResponse, Error, IPatchActionParams<TBody>>;
}

export const usePatchMutation = <TResponse, TBody = unknown>(
  params?: IUsePatchMutationParams<TResponse, TBody>,
): UseMutationResult<TResponse, Error, IPatchActionParams<TBody>> => {
  const { mutationOptions } = params ?? {};

  return useMutation<TResponse, Error, IPatchActionParams<TBody>>({
    mutationFn: async (mutationParams) => {
      return patchSectorWorkflowAction<TResponse, TBody>(mutationParams);
    },
    ...mutationOptions,
  });
};
